export enum OneOnOneChatSenderType {
  Unknown = 0,
  Candidate = 1,
  Consultant = 2,
}

export enum OneOnOneChatDelivery {
  Sending = 'sending',
  Sent = 'sent',
  Failed = 'failed',
}

export interface CreateConversationResponse {
  conversationId: string | null;
  conversationSid: string;
}

export type ConversationStatus = 'Unknown' | 'Active' | 'Idle' | 'Archived' | 'Pending';

export interface ConversationResponse {
  conversationId: string;
  status: ConversationStatus;
  readState: { lastReadMessageId: string } | null;
}

export interface MessageDto {
  messageId: string;
  author: string;
  senderType: OneOnOneChatSenderType;
  message: string;
  createdOn: string;
}

export interface ChatMessagePush {
  conversationId: string;
  messageId: string;
  author: string;
  message: string;
  createdOn: string;
}

export interface MessagesPageResponse {
  continuationToken: string | null;
  messages: MessageDto[];
}

/* The server dedupes on clientReferenceId, so a retry with the same value never doubles a message. */
export interface SendMessageRequest {
  message: string;
  clientReferenceId: string;
}

export interface SendMessageResponse {
  messageId: string;
}

export interface OneOnOneChatMessage {
  id: string;
  isOwn: boolean;
  text: string;
  createdOn: Date;
  delivery: OneOnOneChatDelivery;
  /* Only set on messages sent from this device, until the modal closes. */
  clientReferenceId?: string;
}

export interface OneOnOneChatDay {
  day: Date;
  messages: OneOnOneChatMessage[];
}
